// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { Invoice } from '../models/invoice';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends BaseService {
  sendPeppol(id: number): Observable<any> {

    return this.http
      .post<Invoice>(this.basePath + '/v1/invoices/peppol/' + id+ "?expand=workflow,contact,paiements,user,expertise,details",
        {})
      .pipe(
        map((o: any) => Object.assign((new Invoice), o)),
        catchError(this.handleError)
      );

      
  }

  // Verify user credentials on server to get token
  getAll(sortField: string = 'name', sortOrder: number = 2, filters: any,
    first: number, rows: number, outInvoice: boolean = true): Observable<HttpResponse<any[]>> {

      let params = new HttpParams()
        .set('sort',((sortOrder===1) ? '' : '-') + sortField)
        .set('page', ((first/rows)+1).toString())
        .set('per-page', rows.toString())
        .set('expand', 'contact,user,expertise,workflow');

        if (!outInvoice) {
          params = params.set('in-only', '1');
        }

          for (let a in filters) {
      params = params.set(a,filters[a].value);
    }
    return this.http
      .get<any>(this.basePath + '/v1/invoices', {params: params,  observe: 'response'})
      .pipe(
        catchError(this.handleError)
      );
  }
  get(id: number): Observable<Invoice> {
    return this.http
      .get<Invoice>(this.basePath + '/v1/invoices/' + id + "?expand=workflow,peppolid,contact,paiements,user,expertise,details")
      .pipe(
        map((o: any) => Object.assign((new Invoice), o)),
        catchError(this.handleError)
      );
  }

  delete(id: number): Observable<Invoice> {
    return this.http
      .delete<any>(this.basePath + '/v1/invoices/' + id)
      .pipe(
        catchError(this.handleError)
      );
  }

  save(invoice: any): Observable<Invoice> {
    if (invoice.id < 0 ) {
      return this.http
        .post<Invoice>(this.basePath + '/v1/invoices?expand=workflow,contact,paiements,user,expertise,details', Object.assign(invoice, {status: 'InvoiceWorkflow/draft'}))
        .pipe(
          map((o: any) => Object.assign((new Invoice), o)),
          catchError(this.handleError)
        );

    }
    return this.http
      .put<Invoice>(this.basePath + '/v1/invoices/' + invoice.id+ "?expand=workflow,contact,paiements,user,expertise,details", invoice)
      .pipe(
        map((o: any) => Object.assign((new Invoice), o)),
        catchError(this.handleError)
      );
  }
  doWorkflow(invoiceId: number, action: string): Observable<Invoice> {
    return this.http
      .put<Invoice>(this.basePath + '/v1/invoices/workflow/' + invoiceId+ "?expand=workflow,contact,paiements,user,expertise,details",
        {action: action})
      .pipe(
        map((o: any) => Object.assign((new Invoice), o)),
        catchError(this.handleError)
      );
  }

  savePaiements(invoiceId: number, paiements: any[]): Observable<Invoice> {
    return this.http
      .put<Invoice>(this.basePath + '/v1/invoices/paiements/' + invoiceId+ "?expand=workflow,contact,paiements,user,expertise,details",
        {paiements: paiements})
      .pipe(
        map((o: any) => Object.assign((new Invoice), o)),
        catchError(this.handleError)
      );
  }

  getFile(invoiceId: number): Observable<any> {
        return this.http
      .get<any>(this.basePath + '/v1/invoices/file/' + invoiceId)
      .pipe(
        catchError(this.handleError)
      );
  }

  getFile2(invoiceId: number): Observable<any> {
    return this.http
  .get<any>(this.basePath + '/v1/invoices/etat-file/' + invoiceId)
  .pipe(
    catchError(this.handleError)
  );

}


  mailFile(invoiceId: number): Observable<any> {
        return this.http
      .post<any>(this.basePath + '/v1/invoices/mail/' + invoiceId,{})
      .pipe(
        catchError(this.handleError)
      );
  }

}
